/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 17:03:58
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-05-13 18:57:29
 * @Description: file content
 */

Vue.component("share_guide3", {
  props: {
  },
  template: `  <div class="share_guide3">
  <div class="share_mask" @click="clickClose">
    <div class="share_line">
      <span></span>
      <img src="https://assets.rurushishi.com/activies/mfAct/sharelight.png" alt />
    </div>
    <div class="txt1">
      因为
      <span class="txt1_span">分享</span>，所以世界有了光！
    </div>
    <div class="txt2">好东西必须让更多朋友知道</div>
    <img
      class="tray"
      src="https://assets.rurushishi.com/yq-rs-make/components/share_guide3/tray.png"
      alt
    />
  </div>
</div>`,
  methods: {
    clickClose: function () {
      window.myVue.isShowShareGuide3 = false;
    }
  }
})
